import { base } from '@/utils/api'

export default {
  getAllClinicRooms(currentUnityId) {
    return base.get(`rooms/${currentUnityId}/allClinicRooms`)
  },
  getSurgicalMapData(clinicId, start, filters) {
    return base.get(`surgical-map/${clinicId}`, {
      params: { start, filters }
    })
  },
  getRoomReservationByDay(clinicId, date, filters) {
    return base.get(`roomReservations-getByDay/${clinicId}/${date}`, {
      params: { filters }
    })
  }
}
